import { Input } from '@src/design-system/input';
import { useDebounceCallback } from '@src/shared/hooks/use-debounce-args';
import { useState } from 'react';

const TablePaginationPageInput = ({
  setPageIndex,
  totalPages,
}: {
  totalPages: number;
  setPageIndex: (pageIndex: number) => void;
}) => {
  const [pageInput, setPageInput] = useState('');

  const debouncedSetPageIndex = useDebounceCallback((pageIndex: number) => {
    setPageIndex(pageIndex);
  });

  const handleChange = (value: string) => {
    setPageInput(value);
    if (value === '') return;

    let num = Number(value);

    if (num > totalPages) {
      num = totalPages;
      setPageInput(num.toString());
    }
    if (num < 1) {
      num = 1;
      setPageInput('1');
    }

    debouncedSetPageIndex(num - 1);
  };

  return (
    <div className='flex items-center gap-3'>
      <label
        htmlFor='go-to-page'
        className='text-sm font-semibold text-gray-800 whitespace-nowrap'
      >
        Go to
      </label>
      <Input
        placeholder='eg.2'
        type='number'
        min={1}
        max={totalPages}
        value={pageInput}
        className='w-[50px] h-[32px] font-semibold text-sm text-gray-600 rounded-lg border-primary-200 py-0 px-2'
        onChange={(e) => {
          handleChange(e.target.value);
        }}
      />
    </div>
  );
};

export default TablePaginationPageInput;
